import i18n from "@/i18n";
import Vue from 'vue'
Vue.use(i18n);
var soti = [{
  TypeId: '5',
  ParentId: '1',
  Id: '278',
  Name: i18n.t('tvRepair'),
  Image: '/images/icons/tv.svg'
}, {
  TypeId: '5',
  ParentId: '1',
  Id: '279',
  Name: i18n.t('dvdplayer'),
  Image: '/images/icons/soundbar.svg'
}, {
  TypeId: '5',
  ParentId: '1',
  Id: '280',
  Name: i18n.t('digitalReciver'),
  Image: '/images/icons/DVR.svg'
}, {
  TypeId: '5',
  ParentId: '1',
  Id: '297',
  Name: i18n.t('monitorRepair'),
  Image: '/images/icons/monitor.svg'
}, {
  TypeId: '5',
  ParentId: '1',
  Id: '600',
  Name: i18n.t('speakerrepair'),
  Image: '/images/icons/speakers.svg'
}, {
  TypeId: '5',
  ParentId: '1',
  Id: '514',
  Name: i18n.t('micRepair'),
  Image: '/images/icons/microphone.svg'
}, {
  TypeId: '5',
  ParentId: '1',
  Id: '515',
  Name: i18n.t('ampRepair'),
  Image: '/images/icons/amplifier.svg'
}, {
  TypeId: '5',
  ParentId: '1',
  Id: '1238',
  Name: i18n.t('videoCaste'),
  Image: '/images/icons/cassette.svg'
},
  {
    TypeId: '5',
    ParentId: '1',
    Id: '1345',
    Name: i18n.t('controlRepair'),
    Image: '/images/icons/remote.svg'
  },
]
var projector = [{
  TypeId: '5',
  ParentId: '71',
  Id: '292',
  Name: i18n.t('projectorRepair'),
  Image: '/images/icons/projector.svg'
}]
var game = [
  {
    ParentId: '40',
    TypeId: '5',
    Id: '268',
    Name: i18n.t('xboxrepair'),
    Image: '/images/icons/xbox.png'
  }, {
    ParentId: '40',
    TypeId: '5',
    Id: '842',
    Name: i18n.t('kinektRepair'),
    Image: '/images/icons/kinect.svg'
  }, {
    ParentId: '40',
    TypeId: '5',
    Id: '272',
    Name: i18n.t('psRepair'),
    Image: '/images/icons/ps.svg'
  }, {
    ParentId: '40',
    TypeId: '5',
    Id: '314',
    Name: i18n.t('controllerrepair'),
    Image: '/images/icons/GAME.svg'
  }, {
    ParentId: '40',
    TypeId: '5',
    Id: '1215',
    Name: i18n.t('wiiRepair'),
    Image: '/images/icons/wii.svg'
  }, {
    ParentId: '40',
    TypeId: '5',
    Id: '1344',
    Name: i18n.t('vrRepair'),
    Image: '/images/icons/vr_glass.svg'
  }
]
var mobile = [
  {
    ParentId: '39',
    TypeId: '5',
    Id: '275',
    Name: i18n.t('mobilerepair'),
    Image: '/images/icons/mobile.svg'
  }, {
    ParentId: '39',
    TypeId: '5',
    Id: '276',
    Name: i18n.t('tabletrepair'),
    Image: '/images/icons/tablet.svg'
  }, {
    ParentId: '39',
    TypeId: '5',
    Id: '277',
    Name: i18n.t('applewatchRepair'),
    Image: '/images/icons/smart_watch.svg'
  }, {
    ParentId: '39',
    TypeId: '5',
    Id: '1102',
    Name: i18n.t('headphoneRepair'),
    Image: '/images/icons/headphone.svg'
  }
]
var smart = [
  {
    ParentId: '39',
    TypeId: '5',
    Id: '277',
    Name: i18n.t('applewatchRepair'),
    Image: '/images/icons/smart_watch.svg'
  },
]

var laptop = [
  {
    ParentId: '41',
    TypeId: '5',
    Id: '1',
    Name: i18n.t('laptopRepairs'),
    Image: '/images/icons/laptop.svg'
  }, {
    ParentId: '41',
    TypeId: '5',
    Id: '2',
    Name: i18n.t('pcRepair'),
    Image: '/images/icons/case.svg'
  }, {
    ParentId: '41',
    TypeId: '5',
    Id: '303',
    Name: i18n.t('allInOneRepair'),
    Image: '/images/icons/all_in_one.svg'
  }, {
    TypeId: '5',
    ParentId: '1',
    Id: '297',
    Name: i18n.t('monitorRepair'),
    Image: '/images/icons/monitor.svg'
  }, {
    ParentId: '41',
    TypeId: '5',
    Id: '1232',
    Name: i18n.t('keyboardrepair'),
    Image: '/images/icons/keyboard.svg'
  }, {
    ParentId: '41',
    TypeId: '5',
    Id: '300',
    Name: i18n.t('motherboardrepair'),
    Image: '/images/icons/motherboard.svg'
  }, {
    ParentId: '41',
    TypeId: '5',
    Id: '301',
    Name: i18n.t('gpuRepair'),
    Image: '/images/icons/graphic_card.svg'
  }, {
    ParentId: '41',
    TypeId: '5',
    Id: '302',
    Name: i18n.t('powerRepair'),
    Image: '/images/icons/power.svg'
  }, {
    ParentId: '41',
    TypeId: '5',
    Id: '955',
    Name: i18n.t('adapterRepair'),
    Image: '/images/icons/adapter.svg'
  }, {
    ParentId: '41',
    TypeId: '5',
    Id: '1233',
    Name: i18n.t('mouseRepair'),
    Image: '/images/icons/mouse.svg'
  }
]

var printer = [
  {
    ParentId: '42',
    TypeId: '5',
    Id: '253',
    Name: i18n.t('printerRepair'),
    Image: '/images/icons/printer.svg'
  }, {
    ParentId: '42',
    TypeId: '5',
    Id: '252',
    Name: i18n.t('copyRepair'),
    Image: '/images/icons/copy.svg'
  }, {
    ParentId: '42',
    TypeId: '5',
    Id: '260',
    Name: i18n.t('faxRepair'),
    Image: '/images/icons/fax.svg'
  }, {
    ParentId: '42',
    TypeId: '5',
    Id: '306',
    Name: i18n.t('scannerRepair'),
    Image: '/images/icons/scanner.svg'
  }, {
    ParentId: '42',
    TypeId: '5',
    Id: '305',
    Name: i18n.t('cartrigeRepair'),
    Image: '/images/icons/cartridge.svg'
  }, {
    ParentId: '42',
    TypeId: '5',
    Id: '304',
    Name: i18n.t('kaghazKhordkon'),
    Image: '/images/icons/shredder.svg'
  }, {
    ParentId: '42',
    TypeId: '5',
    Id: '307',
    Name: i18n.t('poolshomar'),
    Image: '/images/icons/money_c.svg'
  }, {
    ParentId: '42',
    TypeId: '5',
    Id: '636',
    Name: i18n.t('lablezan'),
    Image: '/images/icons/label_printer.svg'
  }, {
    ParentId: '42',
    TypeId: '5',
    Id: '1126',
    Name: i18n.t('uniteFusing'),
    Image: '/images/icons/fuse.svg'
  }]
var camera = [
  {
    ParentId: '43',
    TypeId: '5',
    Id: '323',
    Name: i18n.t('camerareapair'),
    Image: '/images/icons/CAMERA.svg'
  }, {
    ParentId: '43',
    TypeId: '5',
    Id: '313',
    Name: i18n.t('lensRepair'),
    Image: '/images/icons/lens.svg'
  }, {
    ParentId: '43',
    TypeId: '5',
    Id: '506',
    Name: i18n.t('cctvRepair'),
    Image: '/images/icons/security_cam.svg'
  }, {
    ParentId: '43',
    TypeId: '5',
    Id: '802',
    Name: i18n.t('radioFlashRepair'),
    Image: '/images/icons/flash.svg'
  }]
var phone = [
  {
    TypeId: '5',
    ParentId: '45',
    Id: '273',
    Name: i18n.t('telephoneRepair'),
    Image: '/images/icons/tel.svg'
  }, {
    TypeId: '5',
    ParentId: '45',
    Id: '274',
    Name: i18n.t('centralRepairs'),
    Image: '/images/icons/tel_sant.svg'
  }]
var flash = [
  {
    TypeId: '5',
    ParentId: '72',
    Id: '289',
    Name: i18n.t('ramRecovery'),
    Image: '/images/icons/RAM.svg'
  }, {
    TypeId: '5',
    ParentId: '72',
    Id: '290',
    Name: i18n.t('hddRecovery'),
    Image: '/images/icons/HARD.svg'
  }, {
    TypeId: '5',
    ParentId: '72',
    Id: '291',
    Name: i18n.t('flashRecovery'),
    Image: '/images/icons/flash.svg'
  }]
var modem = [
  {
    TypeId: '5',
    ParentId: '44',
    Id: '308',
    Name: i18n.t('dvrRepair'),
    Image: '/images/icons/DVR.svg'
  }, {
    TypeId: '5',
    ParentId: '44',
    Id: '309',
    Name: i18n.t('ups'),
    Image: '/images/icons/UPS.svg'
  }, {
    TypeId: '5',
    ParentId: '44',
    Id: '310',
    Name: i18n.t('switch'),
    Image: '/images/icons/switch.svg'
  }, {
    TypeId: '5',
    ParentId: '44',
    Id: '322',
    Name: i18n.t('ccTv'),
    Image: '/images/icons/security_cam.svg'
  }, {
    TypeId: '5',
    ParentId: '44',
    Id: '430',
    Name: i18n.t('Router'),
    Image: '/images/icons/router.svg'
  }, {
    TypeId: '5',
    ParentId: '44',
    Id: '512',
    Name: i18n.t('modem'),
    Image: '/images/icons/modem.svg'
  }, {
    TypeId: '5',
    ParentId: '44',
    Id: '905',
    Name: i18n.t('miner'),
    Image: '/images/icons/miner.svg'
  }]
var personal = [
  {
    TypeId: '5',
    ParentId: '86',
    Id: '525',
    Name: i18n.t('rishtarash'),
    Image: '/images/icons/SHAVER.svg'
  }, {
    TypeId: '5',
    ParentId: '86',
    Id: '526',
    Name: i18n.t('seshovarRepair'),
    Image: '/images/icons/PERSONAL_ELC.svg'
  }, {
    TypeId: '5',
    ParentId: '86',
    Id: '527',
    Name: i18n.t('tamireUto'),
    Image: '/images/icons/HAIR.svg'
  }, {
    TypeId: '5',
    ParentId: '86',
    Id: '625',
    Name: i18n.t('sohanBarghi'),
    Image: '/images/icons/NAIL.svg'
  }, {
    TypeId: '5',
    ParentId: '86',
    Id: '717',
    Name: i18n.t('tattoRepair'),
    Image: '/images/icons/TATTOO.svg'
  }, {
    TypeId: '5',
    ParentId: '86',
    Id: '785',
    Name: i18n.t('uvRepair'),
    Image: '/images/icons/UV.svg'
  }, {
    TypeId: '5',
    ParentId: '86',
    Id: '1137',
    Name: i18n.t('tamireEpilator'),
    Image: '/images/icons/EPILATOR.svg'
  }]
var khanegi = [
  {
    TypeId: '5',
    ParentId: '2',
    Id: '1389',
    Name: i18n.t('tamireYakhchal'),
    Image: '/icons/repair/ref.svg'
  }, {
    TypeId: '5',
    ParentId: '2',
    Id: '1231',
    Name: i18n.t('microwaveRepair'),
    Image: '/icons/repair/microwave.svg'
  }, {
    TypeId: '5',
    ParentId: '2',
    Id: '1390',
    Name: i18n.t('washingmachineRepair'),
    Image: '/images/icons/washer.png'
  }, {
    TypeId: '5',
    ParentId: '2',
    Id: '1391',
    Name: i18n.t('tamireZarfshoee'),
    Image: '/images/icons/dishwasher.png'
  }, {
    TypeId: '5',
    ParentId: '2',
    Id: '1203',
    Name: i18n.t('juicerRepair'),
    Image: '/icons/repair/juice_machine.svg'
  }]
var tahvie = [
  {
    TypeId: '5',
    ParentId: '2',
    Id: '1392',
    Name: i18n.t('coolerGaziRepair'),
    Image: '/images/icons/AIR_CONDITIONER.svg'
  }, {
    TypeId: '5',
    ParentId: '2',
    Id: '1393',
    Name: i18n.t('splitRepair'),
    Image: '/images/icons/AIR_CONDITIONER.svg'
  },];
var beauty = [
  {
    TypeId: '5',
    ParentId: '99',
    Id: '1139',
    Name: i18n.t('tarazoRepair'),
    Image: '/images/icons/HEALTH.svg'
  }
]
var repair_org = [{ TypeId:5, ParentId:168, Id:1709, Name:i18n.t('sazmaniRepair'), Image:'/images/icons/repair_org.svg' }]
var learning_org = [{ TypeId:5, ParentId:169, Id:1716, Name:i18n.t('laptoprepairLearning'), Image:'/images/icons/laptop.svg' }, { TypeId:5, ParentId:169, Id:1717, Name:i18n.t('mobilerepairLearning'), Image:'/images/icons/mobile.svg' }, { TypeId:5, ParentId:169, Id:1718, Name:i18n.t('amozesheMashinEdari'), Image:'/images/icons/printer.svg' }, { TypeId:5, ParentId:169, Id:1719, Name:i18n.t('AmozesheSuti'), Image:'/images/icons/tv.svg' }, { TypeId:5, ParentId:169, Id:1720, Name:i18n.t('amozesheTamirPc'), Image:'/images/icons/case.svg' }, { TypeId:5, ParentId:169, Id:1743, Name:i18n.t('amozesheNarmafzari'), Image:'/images/icons/learning.png' }]
var repair_toys = [{ TypeId:5, ParentId:173, Id:1736, Name:i18n.t('rcCar'), Image:'/images/icons/toys_car.svg' }, { TypeId:5, ParentId:173, Id:1737, Name:i18n.t('helicopter'), Image:'/images/icons/toys_heli.svg' }, { TypeId:5, ParentId:173, Id:1738, Name:i18n.t('quadcopter'), Image:'/images/icons/toys_quad.svg' }, { TypeId:5, ParentId:173, Id:1739, Name:i18n.t('electricScooter'), Image:'/images/icons/toys_scoter.svg' }, { TypeId:5, ParentId:173, Id:1740, Name:i18n.t('batteryCreate'), Image:'/images/icons/toys_battery.svg' }, { TypeId:5, ParentId:173, Id:1741, Name:i18n.t('gearCreateing'), Image:'/images/icons/toys_gear.svg' }, { TypeId:5, ParentId:173, Id:1742, Name:i18n.t('tamineGhateat'), Image:'/images/icons/toys_accesories.svg' }]
var repair_medical = [{ TypeId:5, ParentId:174, Id:1747, Name:i18n.t('dentistUnit'), Image:'/images/icons/medical_unit.svg' }, { TypeId:5, ParentId:174, Id:1748, Name:i18n.t('dentistAutoclav'), Image:'/images/icons/medical_autoclav.svg' }, { TypeId:5, ParentId:174, Id:1749, Name:i18n.t('dentistCompressor'), Image:'/images/icons/toys_compressor.svg' }, { TypeId:5, ParentId:174, Id:1750, Name:i18n.t('radioGeraphi'), Image:'/images/icons/medical_graphy.svg' }, { TypeId:5, ParentId:174, Id:1751, Name:i18n.t('torbineDandanPezeshki'), Image:'/images/icons/medical_torbin.svg' }, { TypeId:5, ParentId:174, Id:1752, Name:i18n.t('angel'), Image:'/images/icons/medical_angel.svg' }, { TypeId:5, ParentId:174, Id:1753, Name:i18n.t('irometer'), Image:'/images/icons/medical_irometer.svg' }, { TypeId:5, ParentId:174, Id:1754, Name:i18n.t('lightCure'), Image:'/images/icons/toys_light.svg' }]
// *************************
var building_tasisat = [{ TypeId:19, ParentId:108, Id:1643, Name:i18n.t('pool'), Image:'/images/building/pool.svg' }, { TypeId:19, ParentId:108, Id:1644, Name:i18n.t('motorKhane'), Image:'/images/building/package.svg' }, { TypeId:19, ParentId:108, Id:1272, Name:i18n.t('lolekeshi'), Image:'/images/building/piping.svg' }, { TypeId:19, ParentId:108, Id:1642, Name:i18n.t('ac'), Image:'/images/building/tahvie.svg' }]
var building_banaii = [{ TypeId:19, ParentId:109, Id:1283, Name:i18n.t('skeleton'), Image:'/images/building/pei.svg' }, { TypeId:19, ParentId:109, Id:1280, Name:i18n.t('banaee'), Image:'/images/building/gachkari.svg' }, { TypeId:19, ParentId:109, Id:1302, Name:i18n.t('kashi'), Image:'/images/building/tile.svg' }, { TypeId:19, ParentId:109, Id:1630, Name:i18n.t('doorWindows'), Image:'/images/building/door.svg' }, { TypeId:19, ParentId:109, Id:1631, Name:i18n.t('shisheNama'), Image:'/images/building/shishe.svg' }]
var building_hoshmand = [{ TypeId:19, ParentId:110, Id:1297, Name:i18n.t('bms'), Image:'/images/building/bms.svg' }]
var building_asansor = [{ TypeId:19, ParentId:111, Id:1635, Name:i18n.t('elavator'), Image:'/images/building/elevator.svg' }, { TypeId:19, ParentId:111, Id:1636, Name:i18n.t('escalator'), Image:'/images/building/pelebarghi.svg' }, { TypeId:19, ParentId:111, Id:1637, Name:i18n.t('darbeAuyomat'), Image:'/images/building/auto_door.svg' }]
var building_bargh_kari = [{ TypeId:19, ParentId:112, Id:1645, Name:i18n.t('tabloBargh'), Image:'/images/building/electric_tablo.svg' }, { TypeId:19, ParentId:112, Id:1294, Name:i18n.t('barghkeshi'), Image:'/images/building/electric.svg' }, { TypeId:19, ParentId:112, Id:1646, Name:i18n.t('norpardazi'), Image:'/images/building/light.svg' }, { TypeId:19, ParentId:112, Id:1647, Name:i18n.t('tamiratBargh'), Image:'/images/building/tamir_bargh.svg' }]
var building_joshkari = [{ TypeId:19, ParentId:113, Id:1634, Name:i18n.t('ahangari'), Image:'/images/building/joshkari.svg' }]
var building_decor = [{ TypeId:19, ParentId:138, Id:1638, Name:i18n.t('rabits'), Image:'/images/building/rabits.svg' }, { TypeId:19, ParentId:138, Id:1639, Name:i18n.t('naghashi'), Image:'/images/building/naghashi.svg' }, { TypeId:19, ParentId:138, Id:1640, Name:i18n.t('parket'), Image:'/images/building/parket.svg' }, { TypeId:19, ParentId:138, Id:1641, Name:i18n.t('parde'), Image:'/images/building/parde.svg' }]
//* **********************************************************************************************
var software_web = [{ TypeId:28, ParentId:157, Id:1671, Name:i18n.t('sazmani'), Image:'/images/website/org_portal.svg' }, { TypeId:28, ParentId:157, Id:1672, Name:i18n.t('tablightTahteWeb'), Image:'/images/website/ads_portal.svg' }, { TypeId:28, ParentId:157, Id:1673, Name:i18n.t('amozsheTahteWeb'), Image:'/images/website/learn_portal.svg' }, { TypeId:28, ParentId:157, Id:1674, Name:i18n.t('samaneSefareshi'), Image:'/images/website/specific_portal.svg' }, { TypeId:28, ParentId:157, Id:1675, Name:i18n.t('sayereSamaneha'), Image:'/images/website/other_portal.svg' }]
var software_mobile = [{ TypeId:28, ParentId:158, Id:1669, Name:i18n.t('android'), Image:'/images/website/android.svg' }, { TypeId:28, ParentId:158, Id:1670, Name:i18n.t('iosApp'), Image:'/images/website/ios.svg' }]
var software_windows = [{ TypeId:28, ParentId:159, Id:1676, Name:i18n.t('samaneSazmani'), Image:'/images/website/org_portal_win.svg' }, { TypeId:28, ParentId:159, Id:1677, Name:i18n.t('sefareshiApp'), Image:'/images/website/sefareshi_app.svg' }, { TypeId:28, ParentId:159, Id:1678, Name:i18n.t('multimediaApp'), Image:'/images/website/media_app.svg' }, { TypeId:28, ParentId:159, Id:1679, Name:i18n.t('narmafzareBazi'), Image:'/images/website/game_app.svg' }, { TypeId:28, ParentId:159, Id:1680, Name:i18n.t('otherWindowsApp'), Image:'/images/website/win_app.svg' }]
var software_seo = [{ TypeId:28, ParentId:160, Id:1667, Name:i18n.t('webDesign'), Image:'/images/website/web_design.svg' }, { TypeId:28, ParentId:160, Id:1668, Name:i18n.t('webSeo'), Image:'/images/website/web_seo.svg' }]
var software_moshavere = [{ TypeId:28, ParentId:161, Id:1681, Name:i18n.t('ideaCounseling'), Image:'/images/website/software_idea.svg' }, { TypeId:28, ParentId:161, Id:1682, Name:i18n.t('moshaveresoftware'), Image:'/images/website/software_tahlil.svg' }, { TypeId:28, ParentId:161, Id:1683, Name:i18n.t('moshavereTolideNarmafzar'), Image:'/images/website/software_design.svg' }, { TypeId:28, ParentId:161, Id:1684, Name:i18n.t('moshavereTaghireNarmafzar'), Image:'/images/website/taghirnarmafzar.svg' }, { TypeId:28, ParentId:161, Id:1685, Name:i18n.t('moshavereSayer'), Image:'/images/website/moshavere_saier_software.svg' }]
//* **********************************************************************************************
var graphic_catalog = [{ TypeId:27, ParentId:154, Id:1661, Name:i18n.t('catalogDesign'), Image:'/images/graphic/catalog.svg' }, { TypeId:27, ParentId:154, Id:1662, Name:i18n.t('catalogPrint'), Image:'/images/graphic/print_catalog.svg' }]
var graphic_logo = [{ TypeId:27, ParentId:155, Id:1663, Name:i18n.t('logoDesign'), Image:'/images/graphic/design_logo.svg' }, { TypeId:27, ParentId:155, Id:1664, Name:i18n.t('logoPrint'), Image:'/images/graphic/print_logo.svg' }]
var graphic_set = [{ TypeId:27, ParentId:156, Id:1665, Name:i18n.t('headerDesign'), Image:'/images/graphic/design_set.svg' }, { TypeId:27, ParentId:156, Id:1666, Name:i18n.t('headerPrint'), Image:'/images/graphic/print_set.svg' }]

/// ***********************************************************************************************
var network_network = [{ TypeId:26, ParentId:150, Id:1652, Name:i18n.t('networkActive'), Image:'/images/it/network_active.svg' }, { TypeId:26, ParentId:150, Id:1653, Name:i18n.t('passiveNetwork'), Image:'/images/it/network_passive.svg' }, { TypeId:26, ParentId:150, Id:1654, Name:i18n.t('otherServices'), Image:'/images/it/network_another.svg' }]
var network_server = [{ TypeId:26, ParentId:151, Id:1649, Name:i18n.t('serverInstallling'), Image:'/images/it/config_server.svg' }, { TypeId:26, ParentId:151, Id:1650, Name:i18n.t('serverDiag'), Image:'/images/it/repair_server.svg' }, { TypeId:26, ParentId:151, Id:1651, Name:i18n.t('serverSupport'), Image:'/images/it/backup_server.svg' }]
var network_voip = [{ TypeId:26, ParentId:152, Id:1655, Name:i18n.t('voipInstalling'), Image:'/images/it/voip_config.svg' }, { TypeId:26, ParentId:152, Id:1656, Name:i18n.t('voipDiag'), Image:'/images/it/voip_repair.svg' }, { TypeId:26, ParentId:152, Id:1657, Name:i18n.t('voipSupport'), Image:'/images/it/voip_backup.svg' }]
var network_santral = [{ TypeId:26, ParentId:153, Id:1658, Name:i18n.t('centralInstalling'), Image:'/images/it/santral.svg' }, { TypeId:26, ParentId:153, Id:1659, Name:i18n.t('centralDiag'), Image:'/images/it/santral.svg' }, { TypeId:26, ParentId:153, Id:1660, Name:i18n.t('centralSupport'), Image:'/images/it/santral.svg' }]
/// ***********************************************************************************************
var work_startup = [{ TypeId:29, ParentId:162, Id:1689, Name:i18n.t('startupCounseling'), Image:'/images/startup/startup_moshavere.svg' }, { TypeId:29, ParentId:162, Id:1690, Name:i18n.t('startup Design'), Image:'/images/startup/startup_design.svg' }, { TypeId:29, ParentId:162, Id:1691, Name:i18n.t('doingStartup'), Image:'/images/startup/startup_start.svg' }, { TypeId:29, ParentId:162, Id:1692, Name:i18n.t('ejrayeStartup'), Image:'/images/startup/startup_run.svg' }, { TypeId:29, ParentId:162, Id:1693, Name:i18n.t('poshtibaniStartup'), Image:'/images/startup/startup_backup.svg' }, { TypeId:29, ParentId:162, Id:1694, Name:i18n.t('mosharekatStartup'), Image:'/images/startup/startup_mosharekat.svg' }, { TypeId:29, ParentId:162, Id:1695, Name:i18n.t('sellingStartup'), Image:'/images/startup/startup_sell.svg' }, { TypeId:29, ParentId:162, Id:1696, Name:i18n.t('buyingStartup'), Image:'/images/startup/startup_buy.svg' }]
var work_franchize = [{ TypeId:29, ParentId:163, Id:1697, Name:i18n.t('namayandegiZoodkomak'), Image:'/images/startup/franchise_town.svg' }, { TypeId:29, ParentId:163, Id:1698, Name:i18n.t('feranchiseZoodkomak'), Image:'/images/startup/franchise_foreign.svg' }, { TypeId:29, ParentId:163, Id:1699, Name:i18n.t('vagozariBeZoodkomak'), Image:'/images/startup/franchise_zoodkomak.svg' }]
/// ***********************************************************************************************

var furnish_home =
  [{
    TypeId: 23,
ParentId: 133,
Id: 1482,
    Name: i18n.t('shoesBoxes'),
    Image: '/images/furnishium_category/shoes.png'
  }, {
    TypeId: 23,
    ParentId: 133,
    Id: 1483,
    Name: i18n.t('mizeMobl'),
    Image: '/images/furnishium_category/jelo_mobli.png'
  }, {
    TypeId: 23,
ParentId: 133,
Id: 1484,
    Name: i18n.t('closet'),
    Image: '/images/furnishium_category/drawer.png'
  }, {
    TypeId: 23,
    ParentId: 133,
    Id: 1485,
    Name: i18n.t('console'),
    Image: '/images/furnishium_category/console.png'
  }, {
    TypeId: 23,
ParentId: 133,
Id: 1486,
    Name: i18n.t('library'),
    Image: '/images/furnishium_category/library.png'
  }, {
    TypeId: 23,
    ParentId: 133,
    Id: 1487,
    Name: i18n.t('tvShelf'),
    Image: '/images/furnishium_category/shelf_tv.png'
  }, {
    TypeId: 23,
ParentId: 133,
Id: 1488,
    Name: i18n.t('tvMiz'),
    Image: '/images/furnishium_category/tv_table.png'
  }, {
    TypeId: 23,
    ParentId: 133,
    Id: 1489,
    Name: i18n.t('tvWallbox'),
    Image: '/images/furnishium_category/tv_box.png'
  }, {
    TypeId: 23,
ParentId: 133,
Id: 1490,
    Name: i18n.t('shelf'),
    Image: '/images/furnishium_category/shelf.png'
  },
    { TypeId:23, ParentId:133, Id:1714, Name:i18n.t('homeset'), Image:'/images/furnishium_category/drawer.png' }
  ]
var furnish_office = [{
  TypeId: 23,
ParentId: 134,
  Id: 1492,
  Name: i18n.t('mizeKarmandi'),
  Image: '/images/furnishium_category/employer.png'
}, {
  TypeId: 23,
  ParentId: 134,
  Id: 1493,
  Name: i18n.t('mizeModir'),
  Image: '/images/furnishium_category/modiriat.png'
}, {
  TypeId: 23,
ParentId: 134,
Id: 1494,
  Name: i18n.t('mizeTahrir'),
  Image: '/images/furnishium_category/tahrir.png'
}, {
  TypeId: 23,
  ParentId: 134,
  Id: 1495,
  Name: i18n.t('mizeComputer'),
  Image: '/images/furnishium_category/computer.png'
}, {
  TypeId: 23,
ParentId: 134,
Id: 1496,
  Name: i18n.t('mizeGrohi'),
  Image: '/images/furnishium_category/group_work.png'
}, {
  TypeId: 23,
  ParentId: 134,
  Id: 1497,
  Name: i18n.t('fileEdari'),
  Image: '/images/furnishium_category/office_file.png'
}, {
  TypeId: 23,
ParentId: 134,
Id: 1498,
  Name: i18n.t('counterPaziresh'),
  Image: '/images/furnishium_category/reception.png'
},

  {
    TypeId: 23,
    ParentId: 134,
    Id: 1500,
    Name: i18n.t('edariSet'),
    Image: '/images/furnishium_category/accesories.png'
  }]
var furnish_kabinet = [{
  TypeId: 23,
  ParentId: 135,
  Id: 1501,
  Name: i18n.t('memberanCabinet'),
  Image: '/images/furnishium_category/membran.png'
}, {
  TypeId: 23,
  ParentId: 135,
  Id: 1502,
  Name: i18n.t('enzoCabinet'),
  Image: '/images/furnishium_category/enzo.png'
}, {
  TypeId: 23,
  ParentId: 135,
  Id: 1504,
  Name: i18n.t('mdfDesign'),
  Image: '/images/furnishium_category/mdf.png'
}, {
  TypeId: 23,
  ParentId: 135,
  Id: 1505,
  Name: i18n.t('libraryDesign'),
  Image: '/images/furnishium_category/vitrin.png'
},
  {
    TypeId: 23,
ParentId: 135,
Id: 1506,
    Name: i18n.t('komodDesign'),
    Image: '/images/furnishium_category/komod_design.png'
  }
]
var furnish_sakhteman = [{
  TypeId: 23,
  ParentId: 136,
Id: 1507,
  Name: i18n.t('fernisheEdari'),
  Image: '/images/furnishium_category/furnish_office.png'
}, {
  TypeId: 23,
  ParentId: 136,
  Id: 1508,
  Name: i18n.t('edariDesign'),
  Image: '/images/furnishium_category/desine_office.png'
}, {
  TypeId: 23,
ParentId: 136,
  Id: 1509,
  Name: i18n.t('vitrinDesign'),
  Image: '/images/furnishium_category/store_design.png'
}, {
  TypeId: 23,
  ParentId: 136,
  Id: 1510,
  Name: i18n.t('daftarekarDesign'),
  Image: '/images/furnishium_category/work_ofice_design.png'
}, {
  TypeId: 23,
ParentId: 136,
Id: 1624,
  Name: i18n.t('tejariDesign'),
  Image: '/images/furnishium_category/tejari_design.png'
}, {
  TypeId: 23,
  ParentId: 136,
  Id: 1625,
  Name: i18n.t('roofgardenDesign'),
  Image: '/images/furnishium_category/roofgarden.png'
}, {
  TypeId: 23,
ParentId: 136,
  Id: 1626,
  Name: i18n.t('homeDesign'),
  Image: '/images/furnishium_category/home_interior_design.png'
}, {
  TypeId: 23,
  ParentId: 136,
  Id: 1627,
  Name: i18n.t('labiDesign'),
  Image: '/images/furnishium_category/loby.png'
},
]
//* **********************************************************************************************
var company_company = [{
  TypeId: 24,
  ParentId: 140,
  Id: 1559,
  Name: i18n.t('sherkatMahdod'),
  Image: '/images/company_category/set_company.png'
}, {
  TypeId: 24,
ParentId: 140,
Id: 1560,
  Name: i18n.t('sahamiKhas'),
  Image: '/images/company_category/set_company.png'
},

  {
    TypeId: 24,
ParentId: 140,
Id: 1562,
    Name: i18n.t('daneshBonyan'),
    Image: '/images/company_category/set_company.png'
  }, {
    TypeId: 24,
ParentId: 140,
Id: 1564,
    Name: i18n.t('moasese'),
    Image: '/images/company_category/set_company.png'
  }]
var company_brand = [{
  TypeId: 24,
ParentId: 141,
  Id: 1568,
Name: i18n.t('brand'),
  Image: '/images/company_category/brand.png'
}, {
  TypeId: 24,
  ParentId: 141,
  Id: 1569,
  Name: i18n.t('solheBrand'),
  Image: '/images/company_category/solh_brand.png'
}, {
  TypeId: 24,
ParentId: 141,
Id: 1570,
  Name: i18n.t('ebtaleTejari'),
  Image: '/images/company_category/ebtal_alamt_tejari.png'
}, {
  TypeId: 24,
  ParentId: 141,
  Id: 1571,
  Name: i18n.t('alamateTejari'),
  Image: '/images/company_category/alamat_tejari.png'
}, {
  TypeId: 24,
ParentId: 141,
Id: 1572,
  Name: i18n.t('tarheSanati'),
  Image: '/images/company_category/tarh_sanati.png'
}, {
  TypeId: 24,
  ParentId: 141,
  Id: 1573,
  Name: i18n.t('ekhtera'),
  Image: '/images/company_category/ekhtera.png'
}]
var company_bazargani =
  [{
    TypeId: 24,
ParentId: 142,
Id: 1574,
    Name: i18n.t('carteBazargani'),
    Image: '/images/company_category/kart_bazargani.png'
  }, {
    TypeId: 24,
    ParentId: 142,
    Id: 1575,
    Name: i18n.t('carteOzviyat'),
    Image: '/images/company_category/kart_ozviat.png'
  }, {
    TypeId: 24,
    ParentId: 142,
Id: 1576,
    Name: i18n.t('ebtaleBazargani'),
    Image: '/images/company_category/ebtal_bazargani.png'
  }, {
    TypeId: 24,
    ParentId: 142,
    Id: 1577,
    Name: i18n.t('tamdideBazargani'),
    Image: '/images/company_category/tamdid_bazargani.png'
  }]
var company_company_rating = [{
  TypeId: 24,
  ParentId: 143,
  Id: 1581,
  Name: i18n.t('iso'),
  Image: '/images/company_category/iso_certificate.png'
}, {
  TypeId: 24,
ParentId: 143,
Id: 1582,
  Name: i18n.t('rotbeSherkat'),
  Image: '/images/company_category/ranking.png'
}]
var company_javaz_tasis = [{
  TypeId: 24,
  ParentId: 144,
  Id: 1578,
  Name: i18n.t('parvaneKasb'),
  Image: '/images/company_category/parvane_kar.png'
}, {
  TypeId: 24,
ParentId: 144,
Id: 1579,
  Name: i18n.t('javazeTasis'),
  Image: '/images/company_category/javaz_tasis.png'
}, {
  TypeId: 24,
  ParentId: 144,
  Id: 1580,
  Name: i18n.t('parvaneBahrebardari'),
  Image: '/images/company_category/parvane_bahre.png'
}]
var company_get_code = [{
  TypeId: 24,
ParentId: 145,
  Id: 1565,
  Name: i18n.t('eghtesadi'),
  Image: '/images/company_category/set_company.png'
}, {
  TypeId: 24,
  ParentId: 145,
  Id: 1566,
  Name: i18n.t('kargahi'),
  Image: '/images/company_category/code_kargahi.png'
}]
//* **********************************************************************************************
var advertise_mohiti = [{
TypeId: 25,
ParentId: 148,
Id: 1604,
  Name: i18n.t('billboard'),
  Image: '/images/advertise/bilboard.svg'
}, {
  TypeId: 25,
  ParentId: 148,
  Id: 1605,
  Name: i18n.t('straboard'),
  Image: '/images/advertise/straboard.svg'
}, {
TypeId: 25,
ParentId: 148,
Id: 1606,
  Name: i18n.t('stationBoard'),
  Image: '/images/advertise/station_board.svg'
}, {
  TypeId: 25,
  ParentId: 148,
  Id: 1607,
  Name: i18n.t('poleAber'),
  Image: '/images/advertise/pol_aber.svg'
}, {
TypeId: 25,
ParentId: 148,
Id: 1608,
  Name: i18n.t('ploeSavare'),
  Image: '/images/advertise/pol_savare.svg'
}, {
  TypeId: 25,
  ParentId: 148,
  Id: 1609,
  Name: i18n.t('chap'),
  Image: '/images/advertise/print.svg'
}, {
  TypeId: 25,
ParentId: 148,
Id: 1610,
  Name: i18n.t('akasiTablighati'),
  Image: '/images/advertise/photography.svg'
}, {
  TypeId: 25,
  ParentId: 148,
  Id: 1611,
  Name: i18n.t('sedaSima'),
  Image: '/images/advertise/seda_sima.svg'
}, {
TypeId: 25,
ParentId: 148,
Id: 1612,
  Name: i18n.t('ghorfeDesign'),
  Image: '/images/advertise/ghorfe.svg'
}, {
  TypeId: 25,
  ParentId: 148,
  Id: 1613,
  Name: i18n.t('Gift'),
  Image: '/images/advertise/ads_gift.svg'
}]
var advertise_majazi = [{
  TypeId: 25,
  ParentId: 149,
  Id: 1614,
  Name: i18n.t('vod'),
  Image: '/images/advertise/VOD.svg'
}, {
  TypeId: 25,
ParentId: 149,
Id: 1615,
  Name: i18n.t('logoDesigning'),
  Image: '/images/advertise/logo.svg'
}, {
  TypeId: 25,
  ParentId: 149,
  Id: 1616,
  Name: i18n.t('websiteDesign'),
  Image: '/images/advertise/website.svg'
}, {
TypeId: 25,
ParentId: 149,
Id: 1617,
  Name: i18n.t('seo'),
  Image: '/images/advertise/seo.svg'
}, {
  TypeId: 25,
  ParentId: 149,
  Id: 1618,
  Name: i18n.t('intagramAdmin'),
  Image: '/images/advertise/instagram.svg'
}]
//* **********************************************************************************************
var cook_sports = [{ TypeId:30, ParentId:166, Id:1702, Name:i18n.t('badansazi'), Image:'/images/cook/gym.svg' }, { TypeId:30, ParentId:166, Id:1701, Name:i18n.t('crossfit'), Image:'/images/cook/cross_fit.svg' }, { TypeId:30, ParentId:166, Id:1700, Name:i18n.t('bodyPump'), Image:'/images/cook/body_pump.svg' }]
var cook_cook = [{ TypeId:30, ParentId:167, Id:1703, Name:i18n.t('amozeshAshpazi'), Image:'/images/cook/learn_cook.svg' }, { TypeId:30, ParentId:167, Id:1707, Name:i18n.t('tarbiyatModares'), Image:'/images/cook/cook_teacher.svg' }, { TypeId:30, ParentId:167, Id:1706, Name:i18n.t('cafeMenu'), Image:'/images/cook/cafe_menu.svg' }, { TypeId:30, ParentId:167, Id:1708, Name:i18n.t('rahandaziCafe'), Image:'/images/cook/cafe_moshavere.svg' }, { TypeId:30, ParentId:167, Id:1704, Name:i18n.t('tarbiyatSarashpaz'), Image:'/images/cook/chef_cook.svg' }]
/// ***********************************************************************************************

//* **********************************************************************************************
var cats = {
  projector: projector,
  modem: modem,
  soti: soti,
  game: game,
  mobile: mobile,
  smart: smart,
  laptop: laptop,
  printer: printer,
  camera: camera,
  phone: phone,
  flash: flash,
  personal: personal,
  tahvie: tahvie,
  home: khanegi,
  beauty: beauty,
  repair_org: repair_org,
  learning_org: learning_org,
  repair_toys: repair_toys,
  repair_medical: repair_medical,
  building_tasisat: building_tasisat,
  building_banaii: building_banaii,
  building_hoshmand: building_hoshmand,
  building_asansor: building_asansor,
  building_bargh_kari: building_bargh_kari,
  building_joshkari: building_joshkari,
  building_decor: building_decor,
  software_web:software_web,
  software_mobile:software_mobile,
  software_windows:software_windows,
  software_seo:software_seo,
  software_moshavere:software_moshavere,
  graphic_catalog:graphic_catalog,
  graphic_logo:graphic_logo,
  graphic_set:graphic_set,
  network_network:network_network,
  network_server:network_server,
  network_voip:network_voip,
  network_santral:network_santral,
  furnish_home: furnish_home,
  furnish_office: furnish_office,
  furnish_kabinet: furnish_kabinet,
  furnish_sakhteman: furnish_sakhteman,
  work_startup:work_startup,
  work_franchize:work_franchize,
  company_company: company_company,
  company_brand: company_brand,
  company_bazargani: company_bazargani,
  company_company_rating: company_company_rating,
  company_javaz_tasis: company_javaz_tasis,
  company_get_code: company_get_code,
  advertise_mohiti: advertise_mohiti,
  advertise_majazi: advertise_majazi,
  cook_sports:cook_sports,
  cook_cook:cook_cook,
}
var types = {
  5:[{
  Id: 'laptop',
  Name: i18n.t('laptopRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/laptop_repair.svg'
  },{
  Id: 'mobile',
  Name: i18n.t('mobileRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/mobile.png'
  },{
  Id: 'camera',
  Name: i18n.t('camerareapair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/camera.svg'
  },{
  Id: 'projector',
  Name: i18n.t('projectorRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/projector.png'
  },{
  Id: 'soti',
  Name: i18n.t('tasviriRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/repair_soti.svg'
  },{
  Id: 'home',
  Name: i18n.t('lavazemkhanegi'),
  Image: 'https://cp.zoodkomak.com/icons/repair/ref.png'
  },{
  Id: 'flash',
  Name: i18n.t('recovery'),
  Image: 'https://cp.zoodkomak.com/icons/repair/flash.png'
  },{
  Id: 'game',
  Name: i18n.t('consoleRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/game.png'
  },{
  Id: 'phone',
  Name: i18n.t('centralRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/phone.png'
  },{
  Id: 'personal',
  Name: i18n.t('lavazemRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/personal.png'
  },{
  Id: 'tahvie',
  Name: i18n.t('sarmayeshGarmayesh'),
  Image: 'https://cp.zoodkomak.com/icons/repair/air_conditioner.png'
  },{
  Id: 'printer',
  Name: i18n.t('mashinEdari'),
  Image: 'https://cp.zoodkomak.com/icons/repair/repair_copy.svg'
  },{
  Id: 'modem',
  Name: i18n.t('hefazati'),
  Image: 'https://cp.zoodkomak.com/icons/repair/wifi_router.png'
  },{
  Id: 'repair_org',
  Name: i18n.t('tamirNegahdari'),
  Image: 'https://cp.zoodkomak.com/images/icons/repair_org.svg'
  },{
  Id: 'learning_org',
  Name: i18n.t('repairLearning'),
  Image: 'https://cp.zoodkomak.com/icons/repair/learning.svg'
  },{
  Id: 'repair_toys',
  Name: i18n.t('toyRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/toys.svg'
  },{
  Id: 'repair_medical',
  Name: i18n.t('pezashkiRepair'),
  Image: 'https://cp.zoodkomak.com/icons/repair/medical.svg'
  }
  ],
  26:[
    {
      Id: 'network_server',
      Name: i18n.t('serverServices'),
      Image: 'https://cp.zoodkomak.com/icons/network/servers.svg'
    },{
      Id: 'network_network',
      Name: i18n.t('networkServices'),
      Image: 'https://cp.zoodkomak.com/icons/network/network.svg'
    },{
      Id: 'network_voip',
      Name: i18n.t('voip'),
      Image: 'https://cp.zoodkomak.com/icons/network/voip.svg'
    },{
      Id: 'network_santral',
      Name: i18n.t('centralServices'),
      Image: 'https://cp.zoodkomak.com/icons/network/central.svg'
    }
  ],
  19:[
    {
      Id: 'building_banaii',
      Name: i18n.t('banayeSakhteman'),
      Image: 'https://cp.zoodkomak.com/icons/building/trowel.svg'
    },
    {
      Id: 'building_tasisat',
      Name: i18n.t('tasisateSakhteman'),
      Image: 'https://cp.zoodkomak.com/icons/building/facilities.svg'
    },{
      Id: 'building_bargh_kari',
      Name: i18n.t('bargheSakhteman'),
      Image: 'https://cp.zoodkomak.com/icons/building/electric.svg'
    },{
      Id: 'building_joshkari',
      Name: i18n.t('ahangari'),
      Image: 'https://cp.zoodkomak.com/icons/building/joshkari.svg'
    },{
      Id: 'building_asansor',
      Name: i18n.t('asansor'),
      Image: 'https://cp.zoodkomak.com/icons/building/elevator.svg'
    },{
      Id: 'building_decor',
      Name: i18n.t('tazenateSakhteman'),
      Image: 'https://cp.zoodkomak.com/icons/building/building.svg'
    },{
      Id: 'building_hoshmand',
      Name: i18n.t('hooshmandsazi'),
      Image: 'https://cp.zoodkomak.com/icons/building/automation.svg'
    },
  ],
  23:[
    {
      Id: 'furnish_home',
      Name: i18n.t('kharidekhanegi'),
      Image: 'https://cp.zoodkomak.com/icons/furnishium/cabinet.svg'
    },
    {
      Id: 'furnish_office',
      Name: i18n.t('kharideEdari'),
      Image: 'https://cp.zoodkomak.com/icons/furnishium/table.svg'
    },
    {
      Id: 'furnish_kabinet',
      Name: i18n.t('tarahiCabinet'),
      Image: 'https://cp.zoodkomak.com/icons/furnishium/design.svg'
    },
    {
      Id: 'furnish_sakhteman',
      Name: i18n.t('tarahiDakheli'),
      Image: 'https://cp.zoodkomak.com/icons/furnishium/interior_design.svg'
    }

  ],
  28:[
    {
      Id: 'software_web',
      Name: i18n.t('webappDesign'),
      Image: 'https://cp.zoodkomak.com/icons/software/application.svg'
    },
    {
      Id: 'software_mobile',
      Name: i18n.t('mobileappDesign'),
      Image: 'https://cp.zoodkomak.com/icons/software/mobile_app.svg'
    },
    {
      Id: 'software_windows',
      Name: i18n.t('windowsappDesign'),
      Image: 'https://cp.zoodkomak.com/icons/software/web_application.svg'
    },
    {
      Id: 'software_moshavere',
      Name: i18n.t('moshavereNarmafzar'),
      Image: 'https://cp.zoodkomak.com/icons/software/moshavere.svg'
    },
    {
      Id: 'software_seo',
      Name: i18n.t('seowebDesign'),
      Image: 'https://cp.zoodkomak.com/icons/software/website.svg'
    }

  ],
  29:[
    {
      Id: 'work_startup',
      Name: i18n.t('startup'),
      Image: 'https://cp.zoodkomak.com/icons/jobs/startup.svg'
    },
    {
      Id: 'work_franchize',
      Name: i18n.t('vagozari'),
      Image: 'https://cp.zoodkomak.com/icons/jobs/franchise.svg'
    },
    {
      Id: '',
      Name: i18n.t('namayandegi'),
      Image: 'https://cp.zoodkomak.com/icons/jobs/naiandegi.svg'
    },
    {
      Id: '',
      Name: i18n.t('hamkari'),
      Image: 'https://cp.zoodkomak.com/icons/jobs/working_with.svg'
    }

  ],
  24:[
    {
      Id: 'company_company',
      Name: i18n.t('sabtesherkat'),
      Image: 'https://cp.zoodkomak.com/icons/company/sherkat.svg'
    },
    {
      Id: 'company_brand',
      Name: i18n.t('sabteBrand'),
      Image: 'https://cp.zoodkomak.com/icons/company/ekhtera.svg'
    },
    {
      Id: 'company_javaz_tasis',
      Name: i18n.t('akhzeJavaz'),
      Image: 'https://cp.zoodkomak.com/icons/company/javaz_tasis.svg'
    },
    {
      Id: 'company_bazargani',
      Name: i18n.t('akhzeCart'),
      Image: 'https://cp.zoodkomak.com/icons/company/bazargani.svg'
    },
    {
      Id: 'company_get_code',
      Name: i18n.t('codeEghtesadi'),
      Image: 'https://cp.zoodkomak.com/icons/company/economic_code.svg'
    },
    {
      Id: 'company_company_rating',
      Name: i18n.t('rotbeSherkat'),
      Image: 'https://cp.zoodkomak.com/icons/company/rating.svg'
    },
  ],
  30:[
    {
      Id: 'cook_sports',
      Name: i18n.t('sport'),
      Image: 'https://cp.zoodkomak.com/icons/company/sports.svg'
    },
    {
      Id: 'cook_cook',
      Name: i18n.t('cooking'),
      Image: 'https://cp.zoodkomak.com/icons/food/chef.svg'
    }
  ],
  25:[
    {
      Id: 'advertise_mohiti',
      Name: i18n.t('advertiseing'),
      Image: 'https://cp.zoodkomak.com/icons/advertise/ads_mohiti.svg'
    },
    {
      Id: 'advertise_majazi',
      Name: i18n.t('eadvertiseing'),
      Image: 'https://cp.zoodkomak.com/icons/advertise/ads_virtual.svg'
    },
  ]
}
var zood_data = {types:types,cats:cats}
export default zood_data
